/* eslint-disable react/jsx-no-constructed-context-values */
import './App.css';

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { filterContext } from './components/context/filterContext';
import AdjustEquipmentRoute from './routes/adjustEquipmentRoute';
import ContractListRoute from './routes/contractListRoute';
import CookieDeclarationRoute from './routes/cookieDeclarationRoute';
import DetailRoute from './routes/detailRoute';
import LandingPageRoute from './routes/landingPageRoute';
import NotFoundRoute from './routes/notFoundRoute';
import ReturnEquipmentRoute from './routes/ReturnEquipmentRoute';
import TermsOfUseRoute from './routes/termsOfUseRoute';
import { useIsMaintenance } from './services/isMaintenance';
import { Locations } from './services/types/contractListRequest';

const App = () => {
  const { instance } = useMsal();
  const authenticated = useIsAuthenticated();

  const [locationContext, setLocationContext] = useState<Locations>({
    soldToParties: [],
  });
  const [divisionContext, setDivisionContext] = useState<string[]>([]);
  const { isMaintenance } = useIsMaintenance();
  const [countryContext, setCountryContext] = useState<string[]>([]);
  const [shipToPartyContext, setShipToPartyContext] = useState<string[]>([]);
  const [contractType, setContractType] = useState('');
  const [contractUsage, setContractUsage] = useState('');
  const [contractStatus, setContractStatus] = useState('');
  const [contractNumber, setContractNumber] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [activeContracts, setActiveContracts] = useState(true);
  const [finishedContracts, setFinishedContracts] = useState(false);
  const [customerReference, setCustomerReference] = useState('');
  const [beginDateStart, setBeginDateStart] = useState<Date | null>(null);
  const [beginDateEnd, setBeginDateEnd] = useState<Date | null>(null);
  const [upToRows, setUpToRows] = useState<number>(10);
  const [offset, setOffset] = useState<number>(0);

  useEffect(() => {
    if (authenticated) {
      instance.loginRedirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance]);

  return (
    <>
      <AuthenticatedTemplate>
        <filterContext.Provider
          value={{
            locations: locationContext,
            divisions: divisionContext,
            countries: countryContext,
            shipToParties: shipToPartyContext,
            contractType,
            contractUsage,
            contractStatus,
            contractNumber,
            serialNumber,
            activeContracts,
            finishedContracts,
            customerReference,
            beginDateStart,
            beginDateEnd,
            upToRows,
            offset,
            setLocations: setLocationContext,
            setDivisions: setDivisionContext,
            setCountries: setCountryContext,
            setShipToParties: setShipToPartyContext,
            setContractType,
            setContractUsage,
            setContractStatus,
            setContractNumber,
            setSerialNumber,
            setActiveContracts,
            setFinishedContracts,
            setCustomerReference,
            setBeginDateStart,
            setBeginDateEnd,
            setUpToRows,
            setOffset,
          }}
        >
          <Routes>
            <Route
              path="detail"
              element={
                isMaintenance ? <Navigate replace to="/" /> : <DetailRoute />
              }
            >
              <Route
                path=":contractNumber/:contractPosition"
                element={
                  isMaintenance ? <Navigate replace to="/" /> : <DetailRoute />
                }
              />
            </Route>
            <Route
              path="detail/:contractNumber/:contractPosition/returnEquipment"
              element={
                isMaintenance ? (
                  <Navigate replace to="/" />
                ) : (
                  <ReturnEquipmentRoute />
                )
              }
            />
            <Route
              path="detail/:contractNumber/:contractPosition/:showMessage"
              element={
                isMaintenance ? <Navigate replace to="/" /> : <DetailRoute />
              }
            />
            <Route
              path="detail/:contractNumber/:contractPosition/adjustEquipment"
              element={
                isMaintenance ? (
                  <Navigate replace to="/" />
                ) : (
                  <AdjustEquipmentRoute />
                )
              }
            />
            <Route
              path="/"
              element={
                isMaintenance ? <LandingPageRoute /> : <ContractListRoute />
              }
            />
            {/* always redirect to ContractList in case LoggedIn */}
            <Route
              path="contracts"
              element={
                isMaintenance ? (
                  <Navigate replace to="/" />
                ) : (
                  <ContractListRoute />
                )
              }
            />
            <Route
              path="cookieDeclaration"
              element={<CookieDeclarationRoute />}
            />
            <Route path="termsofuse" element={<TermsOfUseRoute />} />
            <Route path="*" element={<NotFoundRoute />} />
          </Routes>
        </filterContext.Provider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Routes>
          <Route path="/" element={<LandingPageRoute />} />
          <Route
            path="cookieDeclaration"
            element={<CookieDeclarationRoute />}
          />
          <Route path="termsofuse" element={<TermsOfUseRoute />} />
          <Route
            path="*"
            element={
              isMaintenance ? <Navigate replace to="/" /> : <NotFoundRoute />
            }
          />
        </Routes>
      </UnauthenticatedTemplate>
    </>
  );
};
export default App;
